import React from 'react';

/** Paper plane, drawn nose-right so a 0° rotation points along the path tangent. */
export default function PlaneIcon(props: React.SVGAttributes<SVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
            <path d="M21.6 11.1 3.5 3.2a.7.7 0 0 0-.95.86l2.2 6.3c.08.23.28.4.52.44l7.2 1.2-7.2 1.2a.7.7 0 0 0-.52.44l-2.2 6.3a.7.7 0 0 0 .95.86l18.1-7.9a.98.98 0 0 0 0-1.8Z" />
        </svg>
    );
}
